// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"343d7e20","224":"63249904","513":"e3cdad33","539":"4e133223","787":"fc237840","894":"df6f2243"}[chunkId] + ".chunk.js";
};